import React, { Component } from 'react';
import { inject, observer } from "mobx-react";
import { withStyles } from '@material-ui/core/styles/index';
import { Fab, Tooltip } from "@material-ui/core";
import Header from '../../../template/Header/Header';
import styles from '../../../assets/jss/pages/novoDocumentoStyle.js';
import Profile from '../../../template/Header/Profile';
import { withRouter } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import SaveIcon from '../../../components/Icon/Save';
import CloseIcon from "@material-ui/icons/Close";
import ButtonLoading from '../../../components/ButtonLoading';
import PageTitle from '../../../components/PageTitle/PageTitle';
import { pageConfiguracoes } from '../../../utils/getPageTitle';
import MultiToggleButtons from '../../../components/Button/MultiToggleButtons';
import { tabs } from '../../../stores/Auditoria.store';
import InformacoesModeloDocumento from './InformacoesModeloDocumento';
import Auditoria from '../../../components/Auditoria/Auditoria';
import { saveDocumentoModelo } from '../../../services/ModeloDocumentoService';
import { findAllDocumentoModeloAuditByDocumentoModeloId } from '../../../services/AuditoriaService';
import string from '../../../utils/string';
import ProfissionalIcon from '../../../components/Icon/ProfissionalIcon';
import { ReactSelectCheckbox } from '../../../components/Select/SelectSearch';
import { checkUserRole } from '../../../utils/checkUserRole';
import Notification from '../../../components/Notification';

@inject("googleAnalyticsStore", "auditoriaStore", "modeloDocumentoStore")
@observer
class ModeloDocumento extends Component {
  constructor(props) {
    super(props);
    this.child = React.createRef();
    this.props.modeloDocumentoStore.reset();
    this.props.modeloDocumentoStore.id = parseInt(this.props.match.params.id);
  }

  state = {
    documentModelRaw: '',
    saving: false,
    pageTitle: "",
    tabSelected: tabs.INFORMACOES,
    showFilterProfissional: false,
    switchValue:false,
    notification: {
      isOpen: false,
      message: '',
      variant: ''
    }
  };

  async componentDidMount() {
    const { modeloDocumentoStore, auditoriaStore } = this.props;

    this.getPageTitle();
    await modeloDocumentoStore.carregaCamposSistema();

    const canViewFilterProfissional = await checkUserRole('ROLE_DOCUMENTO_MODELO_READ_OUTROS_PROFISSIONAIS');

    canViewFilterProfissional && modeloDocumentoStore.profissionaisSaude.length === 0 && await modeloDocumentoStore.getProfissionais();

    const isNew = !parseInt(this.props.match.params.id);
    if (isNew) {
      modeloDocumentoStore.profissionalSaudeSelected = [
        { id: 'todos', nome: 'Todos' },
        ...modeloDocumentoStore.profissionaisSaude,
      ];
    }

    this.setState({ showFilterProfissional: canViewFilterProfissional });
    auditoriaStore.auditoriaProps={
      ...auditoriaStore.auditoriaProps,
      auditoria: "o modelo de documento",
      auditoriaTela: "documentoModelo",
    }

    const paginaVisualizada = {
      page: '/#/configuracoes/modelos-documento/ID/editar', 
      title: 'Configurações - Editar modelo de documento'
    }
    this.props.googleAnalyticsStore.pageView(paginaVisualizada);
  }

  getPageTitle = () => {
    const acao = window.location.hash.includes("criar") ? "Novo" : "Editar";
    this.setState({ pageTitle: pageConfiguracoes(`${acao} modelo de documento`) });
  };

  handleUserCampos = el => {
    this.child.current.insertText(el, 'USUARIO');
  };

  handleCamposDoSistema = el => {
    const formated = '${' + el.entidade + '.' + el.campo + '}';
    this.child.current.insertText(formated, 'SISTEMA');
  };


  openNotification = (message, variant = 'info') => {
    this.setState({
      notification: {
        isOpen: true,
        message,
        variant
      }
    });
  };

  closeNotification = () => {
    this.setState({
      notification: {
        ...this.state.notification,
        isOpen: false
      }
    });
  };

  resetNotification = () => {
    this.setState({
      notification: {
        isOpen: false,
        message: '',
        variant: ''
      }
    });
  };

  handleSubmit = async () => {
    try {
      const { modeloDocumentoStore } = this.props;
      const { id, documentName, ativo, profissionalSaudeSelected, tipo } = modeloDocumentoStore;
  
      if(!documentName){
        return;
      }
      const text = this.child.current.handleSubmitFromChild();
      const images = this.child.current.handleSubmitImagesFromChild();
  
      this.setState({
        documentModelRaw: text,
        saving: true
      });
  
      const tableStyle  = `
        <style>
          table, th, td {
            border: 1px solid;
          }
        </style>
      `;
  
      const withUUIDImages = images.filter((image) => {
        return string.isUUID(String(image.id));
      }).filter(
      (image, index, self) =>
        index === self.findIndex((img) => img.id === image.id)
    );

      const imagesToSend = id ? 
        images.filter(image => !modeloDocumentoStore.existingImageIds.includes(image.id)) :
        withUUIDImages;
  
      const documentoModelo = {
        nome: documentName,
        documentoModeloImagens: imagesToSend || [],
        modelo:  `${!id ? tableStyle : ''} \n ${text}`,
        id: id || undefined,
        ativo: ativo,
        profissionaisSaude: profissionalSaudeSelected?.length > 0
          ? profissionalSaudeSelected.filter(p => p.id !== 'todos').map(p => ({ id: p.id }))
          : [],
        tipo,
      }
  
      await saveDocumentoModelo(documentoModelo);
      this.goToList();
    } catch (error) {
      this.openNotification('Erro ao salvar o modelo de documento', 'error');
    } finally {
      this.setState({saving: false});
    }
  };

  goToList = () => {
    const { history } = this.props;
    history.push('/configuracoes/modelos-documento');
  };

  changeTabSelected = async (tabSelected) => {
    const { auditoriaStore, match } = this.props;

    auditoriaStore.auditoriaProps={
      ...auditoriaStore.auditoriaProps,
      pageNumber: 0,
      lastPage: false,
      auditorias: [],
    }

    if (tabSelected === 1) {
      auditoriaStore.load={
        query: findAllDocumentoModeloAuditByDocumentoModeloId, 
        variableName: "documentoModeloId",
        variableId: match.params.id, 
      }
      await auditoriaStore.loadAuditItems();
    }

    this.setState({ tabSelected });
  };

  handleChangeSwitch =()=>{
    const{switchValue}=this.state;
    this.setState({switchValue:!switchValue})
  }

  renderTab = () => {
    const { tabSelected ,switchValue} = this.state;

    return tabSelected === 0 ? 
      <InformacoesModeloDocumento child={this.child} handleChangeSwitch={this.handleChangeSwitch} switchValue={switchValue}/> 
      : <Auditoria />
  }

  handleProfissionalSaudeChange = (selected) => {
    const { modeloDocumentoStore } = this.props;
    const allOptions = modeloDocumentoStore.profissionaisSaude || [];
    const todosOption = selected?.find(item => item.id === 'todos');
    const prevHadTodos = modeloDocumentoStore.profissionalSaudeSelected?.find(item => item.id === 'todos');

    if (todosOption && !prevHadTodos) {
      modeloDocumentoStore.profissionalSaudeSelected = [{ id: 'todos', nome: 'Todos' }, ...allOptions];
    } else if (!todosOption && prevHadTodos) {
      modeloDocumentoStore.profissionalSaudeSelected = [];
    } else if (!todosOption && selected?.length === allOptions.length) {
      modeloDocumentoStore.profissionalSaudeSelected = [{ id: 'todos', nome: 'Todos' }, ...selected];
    } else {
      modeloDocumentoStore.profissionalSaudeSelected = (selected || []).filter(item => item.id !== 'todos');
    }
  };

  render() {
    const { classes, modeloDocumentoStore } = this.props;
    const { profissionalSaudeSelected } = modeloDocumentoStore;
    const { pageTitle, tabSelected, showFilterProfissional } = this.state;
    const id = parseInt(this.props.match.params.id);
    const profissionaisOptions = [{ id: 'todos', nome: 'Todos' }, ...(modeloDocumentoStore.profissionaisSaude || [])];

    return (
      <>
        <PageTitle title={pageTitle}/>
        <Grid container className={classes.root} wrap={'nowrap'}>
          <Header disableShadow className={classes.header}>
            <div className={classes.titleFilterHeader}>
              <h3 className={classes.titleHeader}>Modelo de documentos</h3>
              {
                showFilterProfissional && (
                  <div className={classes.selectProfissional}>
                    <Tooltip
                      title="Profissional"
                      placement="top"
                    >
                      <ProfissionalIcon />
                    </Tooltip>
                    <ReactSelectCheckbox
                      id='cfg-mdo-sel-prf'
                      className={classes.reactSelect}
                      placeholder={'Selecione'}
                      value={profissionalSaudeSelected}
                      options={profissionaisOptions}
                      getOptionLabel={(option) => option.nome}
                      getOptionValue={(option) => option.id}
                      onChange={this.handleProfissionalSaudeChange}
                    />
                  </div>
                )
              }
            </div>
            <Profile />
          </Header>
          <div className={classes.contentToggleButtons}>
            <MultiToggleButtons
              id='cfg-mdo-btn-tab'
              options={["Informações", "Auditoria"]}
              tabSelected={tabSelected}
              changeTabSelected={this.changeTabSelected}
              classes={{ buttonsContainer: classes.buttonsTab }}
              disabled={!id}
              posicaoDesabilitada={[1]}
            />
          </div>
          <div className={classes.contentTab}>
            { this.renderTab() }
          </div>
        </Grid> 
        <div className={classes.acoes}>
          <ButtonLoading 
            id='cfg-mdo-btn-sal'
            loading={this.state.saving}
            icon={SaveIcon}
            onClick={this.handleSubmit}
          />
          <Fab id='cfg-mdo-btn-can' className={classes.buttonCancelar} onClick={this.goToList} disabled={this.state.saving}>
              <CloseIcon/>
          </Fab>
        </div>
        <Notification
          close={this.closeNotification}
          reset={this.resetNotification}
          isOpen={this.state.notification.isOpen}
          variant={this.state.notification.variant}
          message={this.state.notification.message}
        />
      </>
    );
  }
}

export default withRouter(withStyles(styles)(ModeloDocumento));
